import man from "../../assets/img11.jpeg"

const About = () => {
	return (
		<>
			<section id="about" className='flex app-x flex-col md:flex-row py-20 bg-slate-100'>
				<div className='w-full md:w-2/5 my-auto'>
					<img src={man} alt="man" className='max-w-[24rem] w-full rounded-lg' />
				</div>
				<div className='md:pl-5 w-full md:w-3/5 my-auto'>
					<h3 className='text-primary font-serif text-xl font-bold my-4'>ABOUT US</h3>
					<hr className='w-1/2 border-slate-300' />
					<p className='text-slate-500 text-base my-4'>
						SMARTA Teen Consulting is a community of professionals who are dedicated to helping teens and their families navigate through the maze of teen years, especially those challenging years between 12-18, with minimal stress and lots of fun!
					</p>
					<p className='text-slate-500 text-base my-4'>
						We provide a safe, warm, and supportive environment that helps young adults develop healthy habits, attitudes, skills, and values needed to be successful in their daily lives.
					</p>
				</div>
			</section>
		</>
	)
}

export default About